import { Entity } from '../../../types/models/entity/entity.types';
import { ENTITY_ENDPOINTS } from '../../../utils/api/endpoints/entityEndpoints';

const PREFIX = '[queryPendingEntity]';

export const queryPendingEntity = async () => {
  console.log(PREFIX, `Fetching pending entity infos...`);
  const response = await ENTITY_ENDPOINTS.currentPending();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received pending entity infos.`);
  return json as Entity;
};
